//common
import './common';

//components
import './blocks/media'
import './blocks/tab'
import './blocks/slider-article'
import './blocks/slider-laplandia-features'
import './blocks/slider-laplandia-product'
import './blocks/slider-product-recipes'

function closeText() {
    document.querySelector('.js-text-wraper').classList.remove('open')
    document.querySelector('.js-text-wraper').removeAttribute('style')
    document.querySelector('.js-text-wraper-1').removeAttribute('style')
    document.querySelector('.js-video').removeAttribute('style')
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`.js-open-text`).forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            if(window.innerWidth >= 1024) {
                if(!document.querySelector('.js-text-wraper').classList.contains('open')) {
                    document.querySelector('.js-video').style.width = document.querySelector('.js-video').offsetWidth + 'px'
                    document.querySelector('.js-video').style.height = document.querySelector('.js-video').offsetHeight + 'px'

                    document.querySelector('.js-text-wraper-1').style.minHeight = document.querySelector('.js-text-wraper-1').offsetHeight + 'px'
                    document.querySelector('.js-text-wraper-1').style.width = document.querySelector('.js-text-wraper-1').offsetWidth + 'px'
                    document.querySelector('.js-text-wraper').style.width = document.querySelector('.js-text').offsetWidth - 80 + 'px'

                    document.querySelector('.js-text-wraper').classList.add('open')
                }
                else {
                    closeText()
                }
            }
            else {
                document.querySelector('.js-text-wraper').classList.toggle('open')

                if(document.querySelector('.js-text-wraper').classList.contains('open')) {
                    document.querySelector('.js-text-hidden').style.maxHeight = document.querySelector('.js-text-hidden').scrollHeight + 'px';
                }
                else {
                    document.querySelector('.js-text-hidden').removeAttribute('style')
                }
            }
        });
    });
});

window.addEventListener('resize', () => {
    if(window.innerWidth >= 1024) {
        closeText()
    }
});